import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';

export const TierInfoBox = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '8px 8px 0px 0px',
  marginLeft: '8px',
  backgroundColor: '#F2F8E6',
  height: '24px',
  padding: '4px $sm',
  minWidth: '120px',
  width: 'fit-content',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const SmartChoiceInfoBox = styled('div', {
  dynamic: ({ cssProps: { enableDataCardEnhancements } = {} }) => ({
    display: 'flex',
    justifyContent: enableDataCardEnhancements ? 'flex-start' : 'center',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '8px 8px 0px 0px',
    backgroundColor: 'transparent',
    height: '24px',
    padding: '4px $sm',
    minWidth: '120px',
    width: 'fit-content',
  }),
});

export const TierCardText = styled(Text, {
  marginLeft: '4px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '&.abyss-text-root': {
    dynamic: ({ cssProps: { enableDataCardEnhancements } = {} }) => ({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      color: '#4B4D4F',
      fontSize: enableDataCardEnhancements ? '14px' : '12.64px',
      fontWeight: 'bold',
      lineHeight: '16px ',
    }),
  },
});
export const PremiumCareText = styled(Text, {
  marginLeft: '4px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  color: '#323333 !important',
  fontSize: '14px !important',
  fontWeight: '600 !important',
  lineHeight: '16px ',
});
export const SnackContainer = styled('div', {
  display: 'flex',
  '@media (max-width: 744px)': {
    height: '100%',
  },
});

export const SnackAvatarContainer = styled('div', {
  position: 'relative',
  paddingBottom: '0px',
});

export const SNACK_CARD_BOX_ATTR = 'data-snack-card-box';

export const SnackInfoCard = styled(Flex, {
  variants: {
    isFixes: {
      true: {
        boxShadow: 'none',
        border: 'none',
      },
    },
    isSnackCardWithExternalLink: {
      true: {
        cursor: 'pointer',
      },
    },
    isLoading: {
      true: {
        '@media (max-width: 464px)': {
          maxHeight: '176px',
        },
      },
    },
  },
  width: '192px',
  minHeight: '222px',
  gap: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
  border: ' 1px solid #E5E5E6',
  padding: '12px 8px',
  borderRadius: '8px',
  flexWrap: 'nowrap',
  '.abyss-flex-root': {
    textAlign: 'center',
  },
  '@media (max-width: 744px)': {
    minHeight: '132px',
  },
  '@media (max-width: 464px)': {
    width: '151px',
    padding: '12px 6px',
    minHeight: '132px', //minHeight is already set here, above height is not required
  },
});

export const Avatar = styled(Flex, {
  backgroundColor: '$snackCardAvatarBackgroundColor',
  width: '72px',
  height: '72px',
  borderRadius: '50%',
  overflow: 'hidden',
  '@media (max-width: 464px)': {
    width: '60px',
    height: '60px',
  },
});

export const slideStyleSnack = {
  'abyss-slide-container': {
    backgroundColor: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
    border: ' 1px solid #E5E5E6',

    visibility: 'visible',
    borderRadius: '8px',
    height: 'auto',
    '.abyss-slide-card': {
      padding: '0px',
      borderWidth: '0px',
    },
  },
};

export const slideStyle = (i) => ({
  'abyss-slide-container': {
    backgroundColor: 'white',
    marginLeft: i === 0 ? '0px' : '20px',
    '.abyss-slide-card': {
      border: 'none',
      boxShadow: 'none',
      padding: '0px',
    },
  },
});

export const mixedResultsSlideStyle = (
  i: number,
  count: number,
  isExpandViewAllEnabled: boolean = false
) => ({
  '&.abyss-slide-container': {
    backgroundColor: 'white',
    marginLeft: 0,
    marginRight: isExpandViewAllEnabled
      ? 0
      : count === 2 && i === 0
      ? '16px'
      : '0px',
  },
  'abyss-slide-card': {
    boxShadow: 'none',
    borderWidth: 0,
    padding: '0 0 4px 0',
  },
});

export const slideContainerStyle = {
  'abyss-slide-content-wrapper': {
    padding: '0',
    visibility: 'visible',
    '>div': {
      height: '',
    },
  },
};

export const SlideContentWrapper = styled('div', slideContainerStyle);

export const carouselStyle = {
  'abyss-carousel-root': {
    '@media (max-width: 464px)': {
      zIndex: 0,
    },
  },
  'abyss-carousel-swiper-container': {
    display: 'flex',
    willChange: 'transform',
    marginLeft: '0',
    marginRight: '0',
  },
  'abyss-carousel-slide-container': {
    position: 'relative',
    width: '180px',
    gap: '16px',
    alignItems: 'start',
    '@media (max-width: 464px)': {
      width: '144px',
    },
  },
  'abyss-carousel-minimal-controls': {
    marginTop: '12px',
    padding: '0px',
    height: '20px',
    position: 'absolute',
    bottom: '0',
    right: '0',
    left: '0',
    'button.abyss-carousel-minimal-pagination-container': {
      padding: ' 0 4px 0 4px',
      display: 'block',
      width: 'auto',
    },
  },
  'abyss-carousel-minimal-nav-icon-right': {
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-nav-container-right': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
  'abyss-carousel-minimal-nav-container-left': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },

  'abyss-carousel-minimal-nav-icon-left': {
    width: '20px',
    height: '20px',
  },
  'abyss-carousel-minimal-pagination-container': {
    padding: '0 8px 0 8px',
  },
};

export const SnackDescription = styled(Flex, {
  lineHeight: '16px',
  textAlign: 'center',
});

export const Miles = styled(Flex, {
  cursor: 'pointer',
  justifyContent: 'center',
  gap: '8px',
});

export const MilesContent = styled('button', {
  display: 'flex',
  cursor: 'pointer',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '2px',
  height: '18px',
  '&:focus-visible': {
    boxShadow: '#004BA0 0 0 0 3px',
  },
});

export const SnackName = styled('div', {
  '.abyss-link-root': {
    paddingTop: '8px',
    lineHeight: '20px !important',
    width: '148px',
    fontSize: '$md !important',
    fontWeight: 600,
    wordBreak: 'break-word',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    '@media (max-width: 464px)': {
      fontSize: '14.22px !important',
      fontWeight: 700,
      width: '114px',
    },
  },
});

export const SnackDetails = styled(Flex, {
  marginTop: '-2px',
  gap: '8px',
});

export const MilesText = styled(Text, {
  color: '$milesTextColor !important',
  fontSize: '$extraSmallText !important',
  fontWeight: 700,
});

export const SnackRole = styled('div', {
  dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
    color: isGEHAV2 ? '$core.color.brand.100' : '',
  }),
  lineHeight: '18px !important',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '148px',
  maxHeight: '32px',
  fontSize: '12px',
  bottom: '6px',
  '@media (max-width: 464px)': {
    lineHeight: '14px !important',
    width: '114px',
  },
});

export const NoRatingText = styled(Text, {
  color: '#00172F',
  fontSize: '$extraSmallText !important',
  fontWeight: 500,
  fontStyle: 'italic',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: '16px !important',
  '@media (max-width: 464px)': {
    width: '120px',
  },
});

export const PopoverContainer = styled('div', {
  position: 'relative',
  top: '4px',
  '.abyss-popover-root': {
    zIndex: '9 !important',
  },
});

export const SnackCardPopoverContainer = styled('div', {
  position: 'relative',
});

export const DistanceDrawerStyles = {
  'abyss-modal-base-content-container': {
    borderRadius: '20px 20px 0 0',
    height: 'auto !important',
  },
  'abyss-modal-base-body': {
    margin: '16px 24px 16px 24px',
    color: '#4B4D4F',
  },
  'abyss-modal-close-button': { margin: '8px 10px 0 0' },
  'abyss-modal-content-title': {
    paddingTop: '2px',
    fontFamily: '$primary !important',
    fontSize: '20.25px !important',
    color: '#323334 !important',
    lineHeight: '24px !important',
    fontWeight: '700 !important',
  },
  'abyss-modal-header-container': {
    padding: '16px 24px 0px 24px',
  },
};

export const displayVirtualVisitStyle = {
  'abyss-flex-root': {
    border: '1px solid white',
    display: 'flex',
    borderRadius: '100px',
    background: '$core.color.brand.100',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px',
    width: '24px',
    height: '24px',
    position: 'absolute',
    top: '0px',
    right: '-8px',
    zindex: 1,
  },
};

export const TierOneSnackCardPopoverStyles = {
  '.abyss-popover-content-container': {
    whiteSpace: 'pre-line',
    color: '$core.color.neutral.90',
  },
};

export const SnackCardWithExternalLinkIcon = styled(Flex, {
  height: '24px',
  width: '100%',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  alignContent: 'flex-end',
  alignSelf: 'stretch',
});

export const SnackCardsWithExternalLink = styled(Flex, {
  marginTop: '4px',
  minHeight: '72px',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignSelf: 'stretch',
  alignItems: 'center',
  '@media (max-width: 464px)': {
    height: '36px',
  },
});

export const SnackCardWithExternalLinkText = styled(Button, {
  width: '100%',
  fontSize: '18px !important',
  fontWeight: 600,
  lineHeight: '24px !important',
  '&.abyss-button-root': {
    border: 'none',
    borderRadius: '0px',
    textOverflow: 'ellipsis',
    paddingLeft: '0px',
    paddingRight: '0px',
    height: 'auto',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'white',
    },
    display: 'grid',
    '& span': {
      overflowWrap: 'anywhere',
      display: '-webkit-box',
      '-webkit-line-clamp': '3',
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      color: '$core.color.brand.100 !important',
    },
  },
});

export const SnackCardWithExternalLinkType = styled('div', {
  marginTop: '8px',
  dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
    color: isGEHAV2
      ? '$core.color.brand.100 !important'
      : '$core.color.neutral.80 !important',
  }),
  textAlign: 'center',
  width: '100%',
  fontSize: '12.64px !important',
  fontWeight: 500,
  lineHeight: '$sm !important',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-line-clamp': '1',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
});

export const PlatinumBadgeStyles = {
  '.abyss-badge-root': {
    padding: '0 !important',
  },
  '.abyss-badge-content': {
    '@media (max-width: 464px)': {
      height: '20px',
      marginLeft: '0px !important',
      maxWidth: '120px',
      fontSize: '$xs',
    },
    '@media (min-width: 745px)': {
      maxWidth: '160px',
    },
  },
};

export const SmartChoiceScoreCardContainer = styled('div', {
  justifyContent: 'center',
  display: 'flex',
  width: '100%',
});
export const SmartChoiceScoreBox = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px 8px 0px 0px',
  backgroundColor: '#E5F0E5',
  height: '24px',
  minWidth: '120px',
  padding: '0px 4px',
  width: 'fit-content',
  '@media (max-width: 464px)': {
    minWidth: '111px',
  },
});

export const SmartChoiceScore = styled(Text, {
  '&.abyss-text-root': {
    textAlign: 'center',
    whiteSpace: 'nowrap',
    color: '$core.color.green.100',
    fontWeight: 'bold',
    lineHeight: '16px ',
    '@media (max-width: 464px)': {
      fontSize: '11px',
    },
  },
});

export const SmartChoiceScorePrintView = styled(Text, {
  '&.abyss-text-root': {
    color: '$core.color.green.100',
    fontWeight: 'bold',
    lineHeight: '16px ',
    backgroundColor: '#E5F0E5',
    '@media (max-width: 464px)': {
      fontSize: '11px',
    },
    '@media print': {
      textAlign: 'center',
      whiteSpace: 'nowrap',
      color: '#007000',
      fontFamily: '$primary',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '18px',
    },
  },
});

export const GroupedPinSmartChoiceScore = styled(Text, {
  '&.abyss-text-root': {
    textAlign: 'center',
    whiteSpace: 'nowrap',
    color: '$core.color.green.100',
    fontWeight: 'bold',
    '@media (max-width: 464px)': {
      fontSize: '11px',
    },
  },
});

export const SmartChoiceScoreCardContainerListView = (
  isDataCard,
  expandedProviderListView,
  isAlternativeDataCard
) => ({
  justifyContent: isAlternativeDataCard
    ? 'flex-start'
    : isDataCard && !expandedProviderListView
    ? 'flex-start'
    : 'center',
  marginLeft: isDataCard && !expandedProviderListView ? 16 : 0,
  paddingBottom: isDataCard && expandedProviderListView ? 6 : 0,
  paddingLeft: isAlternativeDataCard && !expandedProviderListView ? '20px' : '',
});

export const GroupedPinSmartChoiceScoreCardContainerListView = {
  justifyContent: 'center',
  marginLeft: 0,
  paddingBottom: 6,
};

export const SmartChoiceScoreBoxListView = {
  paddingLeft: '10px',
  paddingRight: '0px',
  borderRadius: '12px',
  border: '1px solid green',
};

export const SmartChoiceScorePercentageListView = (
  expandedProviderListView: boolean
) => ({
  display: 'inline-block',
  backgroundColor: 'green',
  color: 'white',
  padding: expandedProviderListView ? '4px 8px 2px 6px' : '2px 5px',
  fontSize: expandedProviderListView ? '16px' : '12px',
  marginLeft: '4px',
  borderRadius: '12px',
});

export const GroupedPinSmartChoiceScorePercentageListView = {
  display: 'inline-block',
  backgroundColor: 'green',
  color: 'white',
  padding: '4px 8px 6px 6px',
  fontSize: '16px',
  marginLeft: '4px',
  borderRadius: '12px',
};

export const SmartChoiceScoreBoxMapDatacard = {
  minWidth: '83px',
  height: '20px',
  padding: '0px 6px',
  borderRadius: '12px',
  border: '1px solid green',
  fontSize: '11px',
};
export const SmartChoiceScoreBoxStackedGroupedPinDatacard = {
  alignItems: 'normal',
  minWidth: '83px',
  height: '18px',
  padding: '0px 8px',
  borderRadius: '12px',
  border: '1px solid green',
  fontSize: '11px',
};
export const SmartChoiceScoreMapDatacard = {
  display: 'flex',
  flexWrap: 'nowrap',
  fontSize: '14px',
  backgroundColor: 'green',
  color: 'white',
  padding: '4px 32px 4px 8px',
  marginLeft: '14px',
  height: '22px',
  borderRadius: '0px 0px 4px 4px',
  width: '27px',
};
